import { createBlockRendererMapping } from "@circle-react-shared/BuilderUI/Helpers/blockMappings";
import { BlockRenderer } from "@circle-react-shared/BuilderUI/Renderer/BlockRenderer";
import { SITE_THEMES } from "@circle-react-shared/BuilderUI/SiteThemes/constants";
import { UserThemeManager } from "@circle-react-shared/BuilderUI/ThemeManager/UserThemeManager";
import { useMemo } from "react";
import { formBlocks } from "react/components/SettingsApp/Emails/components/Forms/VisualFormsBuilder/blocks";

import { formToBlocks } from "@/react/components/SettingsApp/Emails/components/Forms/VisualFormsBuilder/blocks/shared/formToBlocks";
import { EndingPage } from "@/react/components/SettingsApp/Emails/components/Forms/VisualFormsBuilder/components/Ending/EndingPage";
import { BlocksContextProvider } from "@/react/components/SettingsApp/Emails/components/Forms/VisualFormsBuilder/contexts/BlocksContext";

import "@circle-react-shared/BuilderUI/styles/builder-ui.css";
import { DeviceProvider } from "@/react/components/shared/BuilderUI/DeviceProvider";

import { useFormRenderingContext } from "../contexts/FormRenderingContext";
import { useFilteredFormForProfileFields } from "../hooks/useFilteredFormForProfileFields";
import { FormWrapper } from "./FormWrapper";

export const FormContent = () => {
  const {
    form,
    isModal,
    titleElement,
    shouldRenderEndingPage,
    usage,
    isLoadingProfileFieldValues,
  } = useFormRenderingContext();
  const filteredForm = useFilteredFormForProfileFields(form);
  const formBlock = useMemo(
    () => formToBlocks(filteredForm, isModal ? titleElement : undefined, true),
    [filteredForm, isModal, titleElement],
  );

  if (isLoadingProfileFieldValues) {
    return null;
  }

  const components = createBlockRendererMapping(formBlocks);
  return (
    <UserThemeManager theme={SITE_THEMES.default_theme.cssVariables}>
      <FormWrapper>
        <BlocksContextProvider
          useFormRenderingContext={useFormRenderingContext}
        >
          {shouldRenderEndingPage ? (
            <EndingPage isModal={isModal} usage={usage} />
          ) : (
            <DeviceProvider>
              <BlockRenderer block={formBlock} components={components} />
            </DeviceProvider>
          )}
        </BlocksContextProvider>
      </FormWrapper>
    </UserThemeManager>
  );
};
